import {Fonts, ThemeMode} from '../../../../shared/constants/AppEnums';
import styled from 'styled-components';
import ListItem from '@material-ui/core/ListItem';

export const NavItem = styled(ListItem)`
  ${(props) => `
      height: 44px;
      margin-top: 2px;
      margin-bottom: 2px;
      width: calc(100% - 16px);
      border-radius: 0 30px 30px 0;
      padding-left:
        ${props.theme.direction === 'ltr' ? 17 + 50 * props.level : 17}px;
      padding-right:
        ${props.theme.direction === 'rtl' ? 17 + 50 * props.level : 17}px;
      
      ${props.theme.breakpoints.up('xl')} {
        padding-left:
        ${props.theme.direction === 'ltr' ? 24 + 50 * props.level : 24}px;
      padding-right:
        ${props.theme.direction === 'rtl' ? 24 + 50 * props.level : 24}px;
          
      },

      & .nav-item-text {
        font-family: ${Fonts.REGULAR};
        font-size: 16px;
        color: ${props.theme.palette.sidebar.textColor};
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        ${props.theme.breakpoints.up('xl')} {
          margin-top: 4px;
          margin-bottom: 4px;
          font-size: 18px;
        }
      }

      & .nav-item-icon {
        color: ${props.theme.palette.sidebar.textColor};
        display: block;
        font-size: 18px;
        ${props.theme.breakpoints.up('xl')} {
        font-size: 20px;
        }
      }

      & .nav-item-icon-arrow {
        color: ${props.theme.palette.sidebar.textColor};
      }

      & .MuiIconButton-root {
        margin-right: -16px;
      }

      &.open, &:hover, &:focus {
        & .nav-item-text {
          font-family: ${Fonts.MEDIUM};
          color: ${props.themeMode === ThemeMode.LIGHT ? '#313541' : '#fff'};
        }

        & .nav-item-icon {
          color: ${props.themeMode === ThemeMode.LIGHT ? '#313541' : '#fff'};
        }

        & .nav-item-icon-arrow {
          color: ${props.themeMode === ThemeMode.LIGHT ? '#313541' : '#fff'};
        }
      }
  `}
`;
